import * as am5xy from '@amcharts/amcharts5/xy';
import * as am5 from '@amcharts/amcharts5';
import { IDatiqGraphSeries } from '../models';

export class DatiqAmCharts5SeriesCandlestickBuilder {
    constructor() {}

    setColor(
        series: am5xy.CandlestickSeries,
        seriesData: IDatiqGraphSeries
    ): this {
        series.columns.template.states.create('riseFromOpen', {
            fill: am5.color(seriesData.color),
            stroke: am5.color(seriesData.color),
        });
        series.columns.template.states.create('dropFromOpen', {
            fill: am5.color(seriesData.color),
            stroke: am5.color(seriesData.color),
        });
        return this;
    }
    addBottomLine(
        series: am5xy.CandlestickSeries,
        seriesData: IDatiqGraphSeries,
        root: am5.Root
    ): this {
        series.bullets.push(() => {
            return am5.Bullet.new(root, {
                sprite: this.createHorizontalLine(root, seriesData),
                locationY: 0,
            });
        });

        return this;
    }
    addTopLine(
        series: am5xy.CandlestickSeries,
        seriesData: IDatiqGraphSeries,
        root: am5.Root
    ): this {
        series.bullets.push(() => {
            return am5.Bullet.new(root, {
                sprite: this.createHorizontalLine(root, seriesData),
                locationY: 1,
            });
        });

        return this;
    }

    setWidth(series: am5xy.CandlestickSeries): this {
        series.columns.template.setAll({
            width: 1,
        });
        return this;
    }

    private createHorizontalLine(
        root: am5.Root,
        seriesData: IDatiqGraphSeries
    ): am5.Rectangle {
        return am5.Rectangle.new(root, {
            fill: am5.color(seriesData.color),
            width: 8,
            height: 1,
            centerX: am5.percent(50),
            centerY: am5.percent(50),
        });
    }
}
